import { Paginator } from "primereact/paginator";
import React, { useContext, useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { Link } from "react-router-dom";
import CreateModal from "./CreateModal";
import UpdateModal from "./UpdateModal";
import { DeleteModal } from "./DeleteModal";
import { TitleContext } from "../../../Context/TitleContext";
import { API_URL, useAxios, rowsPerPageOptions } from "../../../utils/const";
import { Ripple } from "primereact/ripple";

const GroupManagement = () => {
  const { setTitle } = useContext(TitleContext);
  const axiosInstance = useAxios();

  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const [groups, setGroups] = useState({ groups: [], totalRecords: 0 });
  const [groupRecords, setGroupRecords] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState([]);

  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState({ first: 0, rows: 10, page: 0 });
  const [rowPerPage, setRowPerPage] = useState(10);

  useEffect(() => {
    setTitle("USAKTI | Manajemen Kelompok Modul"); // Set judul halaman
  }, [setTitle]);

  useEffect(() => {
    getGroups();
  }, [pagination]);

  const onPageChange = async (event) => {
    setPagination({ first: event.first, rows: event.rows, page: event.page });
  };

  const toggleOpenCreateModal = () => {
    setOpenCreateModal(true);
  };

  const toggleOpenupdateModal = (data) => {
    setOpenUpdateModal(true);
    setSelectedGroup(data);
  };

  const toggleOpenDeleteModal = (data) => {
    setOpenDeleteModal(true);
    setSelectedGroup(data);
  };

  function handleFilter(event) {
    const newData = groups.groups.filter((row) => {
      return row.name.toLowerCase().includes(event.target.value.toLowerCase());
    });
    setGroupRecords(newData);
    setSearch(event.target.value);
  }

  const getGroups = async () => {
    const limit = pagination.rows === "All" ? -1 : pagination.rows;

    const response = await axiosInstance.get(
      `${API_URL}/groups?search=${search}&page=${
        pagination.page + 1
      }&limit=${limit}`
    );
    setGroups({
      groups: response.data.data,
      totalRecords: response.data.totalRecords,
    });
    setGroupRecords(response.data.data);
  };

  const paginationTemplate = {
    layout: "PrevPageLink PageLinks NextPageLink ",
    PrevPageLink: (options) => {
      return (
        <button type="button" className="btn border">
          <span className="p-3">Previous</span>
          <Ripple />
        </button>
      );
    },
    NextPageLink: (options) => {
      return (
        <button type="button" className="btn border">
          <span className="p-3">Next</span>
          <Ripple />
        </button>
      );
    },
  };

  const handleRowChange = (row) => {
    setPagination({ first: 0, rows: row, page: 0 });
  };

  return (
    <div>
      <Toaster position="top-right" />
      <div className="container">
        <div className="card mb-4">
          <div className="card-body">
            <h1>Pengaturan Kelompok Modul</h1>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active">
                Pengaturan Kelompok Modul
              </li>
            </ol>
          </div>
        </div>

        <div className="card">
          <div className="card-body m-3">
            <div className="row">
              <div
                className="col-md-12 d-flex gap-2"
                style={{ justifyContent: "end" }}
              >
                <button
                  className="btn btn-success"
                  onClick={toggleOpenCreateModal}
                >
                  + Tambah
                </button>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-4 text-center offset-md-4">
                <h4>Daftar Kelompok Modul</h4>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-md-6">
                <label>Show</label>
                <select
                  value={pagination.rows}
                  onChange={(e) => handleRowChange(e.target.value)}
                  className="form-select form-select-sm d-inline-block w-auto ms-2"
                >
                  {rowsPerPageOptions.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
                <label style={{ marginLeft: "5px" }}>entries</label>
              </div>
              <div className="col-md-6 text-end">
                <label>Search :</label>
                <input
                  type="text"
                  style={{
                    width: "auto",
                    display: "inline-block",
                    marginLeft: "5px",
                  }}
                  className="form-control form-control-sm"
                  onChange={handleFilter}
                />
              </div>
            </div>

            <div className="table-responsive">
              {/* Tabel Data Kelompok Modul */}
              <table className="table table-striped mt-3">
                <thead>
                  <tr className="text-center">
                    <th>NO</th>
                    <th>NAMA</th>
                    <th>AKSI</th>
                  </tr>
                </thead>
                <tbody>
                  {groupRecords.map((item, index) => (
                    <tr className="text-center" key={item.id}>
                      <td>{index + 1}</td>
                      <td>{item.name}</td>
                      <td>
                        <button
                          onClick={() => toggleOpenupdateModal(item)}
                          className="btn btn-warning text-white me-2"
                        >
                          <i className="fas fa-pen-to-square"></i>
                        </button>
                        <button
                          onClick={() => toggleOpenDeleteModal(item)}
                          className="btn btn-danger text-white"
                        >
                          <i className="fas fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Paginator dari PrimeReact */}
            <div className="row">
              <div className="col-md-6 d-flex align-items-center h-100">
                <p>
                  Showing {pagination.first + 1} to{" "}
                  {pagination.first + groups.groups.length} of{" "}
                  {groups.totalRecords} entries
                </p>
              </div>
              <div className="col-md-6">
                <Paginator
                  first={pagination.first}
                  rows={pagination.rows === "All" ? groups.totalRecords : pagination.rows}
                  totalRecords={groups.totalRecords}
                  onPageChange={onPageChange}
                  template={paginationTemplate}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {openCreateModal && (
        <CreateModal toggleModal={setOpenCreateModal} getGroups={getGroups} />
      )}
      {openUpdateModal && (
        <UpdateModal
          toggleModal={setOpenUpdateModal}
          getGroups={getGroups}
          group={selectedGroup}
        />
      )}
      {openDeleteModal && (
        <DeleteModal
          toggleModal={setOpenDeleteModal}
          getGroups={getGroups}
          group={selectedGroup}
        />
      )}
    </div>
  );
};

export default GroupManagement;
